// pulling content from <meta> tags in app/views/layouts/admin/org.html.haml
export const global = {
  applicationId: document.querySelector("meta[name='algolia-application-id']").content,
  searchKey: document.querySelector("meta[name='algolia-search-key']").content,
  indexName: document.querySelector("meta[name='algolia-index-name']").content,
  adminSiteIds: document.querySelector("meta[name='algolia-admin-site-ids']").content,
  usesAdvancedSiteManagement: document.querySelector("meta[name='algolia-uses-advanced-site-management']").content,
  userId: document.querySelector("meta[name='user-id']").content,
  organizationId: document.querySelector("meta[name='organization-id']").content,
  isTest: document.querySelector("meta[name='test-env']")?.content?.toString() === 'true',
  rolePriorityOrder: ['Client', 'Professional', 'Volunteer', 'Attendee', 'Instructor', 'Driver', 'Employee'],
  algoliaSettings: {
    queryType: 'prefixAll',
    minWordSizefor1Typo: 4,
    minWordSizefor2Typos: 8,
    typoTolerance: true,
    hitsPerPage: 50,
    clickAnalytics: true,
    page: 0
  }
}
